import { MessageCircle, ArrowUp } from "lucide-react";
import { LogoMark } from "./Nav";
import { goTo } from "@/lib/site";
import { SITE, WA_DEFAULT } from "@/lib/site";

const Footer = () => (
    <footer
        data-testid="footer-main-wrapper"
        className="relative border-t border-white/10 bg-ink py-14"
    >
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-8">
                <div className="flex items-center gap-3">
                    <LogoMark className="h-10 w-auto" />
                    <span className="leading-none">
                        <span className="block font-display font-bold tracking-[0.22em] text-white text-lg">
                            {SITE.name}
                        </span>
                        <span className="block font-hud text-[9px] uppercase tracking-[0.3em] text-volt mt-1">
                            {SITE.tagline}
                        </span>
                    </span>
                </div>

                <div
                    data-testid="footer-status-ping-indicator"
                    className="flex items-center gap-2.5 font-hud text-[10px] uppercase tracking-[0.22em] text-slate-400"
                >
                    <span className="relative flex h-2 w-2">
                        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-mint opacity-70" />
                        <span className="relative inline-flex h-2 w-2 rounded-full bg-mint" />
                    </span>
                    Todos os sistemas operacionais
                </div>

                <nav className="flex flex-wrap gap-x-6 gap-y-2">
                    {[
                        ["Serviços", "#servicos"],
                        ["Simulador", "#simulador"],
                        ["Processo", "#processo"],
                        ["Trabalhos", "#trabalhos"],
                        ["Contato", "#contato"],
                    ].map(([label, hash]) => (
                        <a
                            key={hash}
                            href={hash}
                            onClick={(e) => goTo(e, hash)}
                            className="font-hud text-[11px] uppercase tracking-[0.2em] text-slate-400 hover:text-volt transition-colors duration-200"
                        >
                            {label}
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <a
                        href={WA_DEFAULT}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="footer-whatsapp-cta"
                        className="inline-flex items-center gap-2 rounded-full border border-mint/40 px-5 py-2.5 font-hud text-[11px] font-bold uppercase tracking-[0.18em] text-mint hover:bg-mint hover:text-ink transition-colors duration-200"
                    >
                        <MessageCircle size={15} strokeWidth={2.4} />
                        WhatsApp
                    </a>
                    <button
                        onClick={(e) => {
                            e.preventDefault();
                            if (window.__lenis) window.__lenis.scrollTo(0);
                            else window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                        data-testid="footer-back-to-top"
                        aria-label="Voltar ao topo"
                        className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-slate-300 hover:border-volt hover:text-volt transition-colors duration-200"
                    >
                        <ArrowUp size={16} />
                    </button>
                </div>
            </div>

            <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-white/5 pt-6">
                <p className="font-hud text-[10px] uppercase tracking-[0.2em] text-slate-500">
                    © {new Date().getFullYear()} {SITE.name} · Todos os direitos reservados
                </p>
                <p className="font-hud text-[10px] uppercase tracking-[0.2em] text-slate-500">
                    CFTV · Acesso facial · Portões · Suporte 24/7
                </p>
            </div>
        </div>
    </footer>
);

export default Footer;
